type AdProps = {
  lazyRender?: boolean
  sticky?: boolean
  isFeed?: boolean
}
export type AdPlacement = {
  outbrain: OutbrainProps
  taboola: TaboolaProps
  assertive: AssertiveProps
  primis?: Omit<PrimisProps, 'placement'>
  style: Record<string, string | number> | undefined
  props: AdProps
}

export const placementConfigs: Record<string, AdPlacement> = {}
